import script from "./footList.vue?vue&type=script&setup=true&lang=js"
export * from "./footList.vue?vue&type=script&setup=true&lang=js"

import "./footList.vue?vue&type=style&index=0&id=5850c891&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5850c891"]])

export default __exports__